import { render } from "./ForgotPassword.vue?vue&type=template&id=1d9b5a14&scoped=true&lang=pug"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=1d9b5a14&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1d9b5a14"

export default script